import React, { Component } from 'react'

import { Route, Switch } from 'react-router-dom';

import './css/External.css';

import ReceptorAppLayout from './ReceptorAppLayout';
import GuardedRoute from '../shared/GuardedRoute';
import ReceptoresSignIn from '../external/auth/ReceptoresSignIn';
import ReceptoresSignInSso from '../external/auth/ReceptoresSignInSso';
import ReceptoresSignInVerify from '../external/auth/ReceptoresSignInVerify';
import ReceptoresPasswordEmail from '../external/auth/ReceptoresPasswordEmail';
import ReceptoresPasswordReset from '../external/auth/ReceptoresPasswordReset';
import ManifiestoFirma from '../external/onboardig/manifiesto/ManifiestoFirma';
import TimbradoTicketRequest from '../external/autofacturacion/TimbradoTicketRequest';

class ExternalLayout extends Component {

  render() {
    return (
      <Switch>
        <Route path="/ext/manifiesto/:id" component={ ManifiestoFirma } exact />
        <Route path="/ext/autofacturacion/on-demand" component={ TimbradoTicketRequest } exact />

        <Route path="/ext/receptores/auth/login" component={ ReceptoresSignIn } exact />
        <Route path="/ext/receptores/auth/sso" component={ ReceptoresSignInSso } exact />
        <Route path="/ext/receptores/auth/verify" component={ ReceptoresSignInVerify } exact />
        <Route path="/ext/receptores/auth/verify" component={ ReceptoresSignInVerify } exact />
        <Route path="/ext/receptores/password/email" component={ ReceptoresPasswordEmail } exact />
        <Route path="/ext/receptores/password/reset" component={ ReceptoresPasswordReset } exact />

        <GuardedRoute path="/ext/receptores"
          component={ ReceptorAppLayout }
          redirectTo="/bridge/receptores"
        />

      </Switch>

    )
  }

}

export default ExternalLayout;